import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { deviceData } from '../mockData/devices-data';

const DevicesApi = [
  rest.get(`${API_ROOT}device?limit=10&offset=0`, (req, res, ctx) => res(ctx.json(deviceData))),
  rest.get(`${API_ROOT}device/${deviceData.data[0].id}`, (req, res, ctx) => res(ctx.json(deviceData.data[0]))),
  rest.put(`${API_ROOT}device/${deviceData.data[0]?.id}`, (req, res, ctx) => res(ctx.json(deviceData.data[0]))),
];
export default DevicesApi;
